var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      class: _vm.bemBlock,
      attrs: { action: _vm.url, novalidate: "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleSubmit($event)
        }
      }
    },
    [
      _c("BaseFieldText", {
        attrs: {
          "class-label": "sr-only",
          label: _vm.$msg("field.city.zip.code", "storeLocator"),
          name: "postalCode",
          placeholder: _vm.$msg("field.city.zip.code", "storeLocator"),
          required: true,
          "data-missing-error": _vm.$msg(
            "error.message.required",
            "forms",
            null
          )
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "form__actions" }, [
        _c(
          "button",
          {
            class: [
              _vm.bemElement("detect-location"),
              "u-btn-clean",
              "link",
              "link--highlight"
            ],
            attrs: {
              type: "button",
              "data-action": _vm.url,
              disabled: !_vm.isGeolocationActive
            },
            on: { click: _vm.handleGeolocation }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$msg("button.use.my.location", "storeLocator")) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            class: [_vm.bemElement("submit"), "btn btn--primary"],
            attrs: { type: "submit" }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$msg("button.find.stores", "storeLocator")) +
                "\n    "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.formErrorMessage !== ""
        ? _c("p", { class: _vm.bemElement("error-message") }, [
            _vm._v("\n    " + _vm._s(_vm.formErrorMessage) + "\n  ")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }